export const CLAIM_ID_QUERY_LABEL = 'claimId';
export const APPEAL_ID_QUERY_LABEL = 'appealId';
export const INQUIRY_ID_QUERY_LABEL = 'inquiryId';
export const TABS_QUERY_LABEL = 'tab';
export const REASON_CODE_ID_QUERY_LABEL = 'reasonCodeId';
export const RULE_SPEC_KEY_QUERY_LABEL = 'ruleSpecKey';
export const RULE_ID_QUERY_LABEL = 'ruleId';
export const CLIENT_PARTNER_ID_QUERY_LABEL = 'cpid';
export const APPEAL_RESPONSE_ID_QUERY_LABEL = 'appealResponseId';
export const DOCUMENT_REFERENCE_KEY_QUERY_LABEL = 'documentReferenceKey';
export const isApigeeReady: boolean = false; //turn this on when apigee is done

export const ID_VALIDATION_REGEX = /^$|^(?![._-])^[a-zA-Z0-9._-]+$/;
export const notificationMessages = {
  saveGridColumnConfigSuccessNotification: 'Column settings successfully saved',
  createClaimSuccessNotification: 'is created successfully.',
  createClaimFailedNotification: 'Claim not created',
  adjustSavingsSuccessNotification: 'Adjust Savings successfully saved',
  editRuleSuccessNotification: 'Rule update was successful.',
  attachmentDeleteSuccess: 'Rule attachment deleted successfully.',
  attachmentDeleteFail: 'Error deleting rule attachment, please try again.',
  editDocumentReferenceSuccessNotification: 'Document reference update was successful.',
  editDocumentResponseFailedNotification: 'Error updating document reference, please try again.',
  createRuleSuccessNotification: 'Rule created successfuly.',
  documentAttachSuccessNotification: 'Appeal and document upload completed successfully.',
  documentAttachFailedNotification: 'Document attachment was not successful. Appeal not created.',
  createEorSuccessNotification: 'EOR was created. Please check your download folder.',
  appealNoteAddedSuccessNotification: 'Note added successfully.',
  appealNoteDeletedSuccessNotification: 'Note deleted successfully.',
  appealReconsiderationEditSuccessNotification: 'Appeal reconsideration updated successfully.',
  appealReconsiderationErrorNotification:
    'Error updating appeal reconsideration, please try again.',
  clientFeeScheduleFailNotification: 'Error getting client fee schedule, please try again.',
  documentReferencesListErrorNotification: 'Error getting Document Reference list.',
  networkErrorNotification: 'A network error occurred. Please contact an administrator.',
  createAppealSuccessNotification: 'Appeal created successfully.',
  createAppealSuccessUploadDocumentNotification: 'Appeal created successfully. Uploading document',
  editAppealSuccessNotification: 'Appeal update was successful.',
  generalAPIError: 'An API error has occurred. Please try again.',
  generalError: 'An error has occurred. Please try again.',
  createAppealFailedNotification: 'Appeal creation failed. Please check the form and try again.',
  generalLogout: 'Could not validate your Login.',
  inquiryCreated: 'Inquiry created successfully.',
  inquiryUpdated: 'Inquiry update was successful',
  inquiryBulkUpdated: 'Inquiry bulk update was successful',
  inquiryCreationError: 'Error creating inquiry, please try again.',
  inquiryUpdateError: 'Error updating inquiry, please try again.',
  inquiryBulkUpdateError: 'Error bulk updating inquiry, please try again.',
  documentDeleteSuccessNotification: 'Attachment deleted successfully.',
  attachmentDeleteError: 'Error deleting the document, please try again.',
  documentTypeDeleteSuccessNotification: 'Document type deleted successfully.',
  attachmentSuccessMessage: 'Document deleted successfully.',
  attachmentErrorMessage: 'The file cannot be uploaded.',
  responseToInquiryAdded: 'Response added successfully.',
  responseToInquiryError: 'Error adding response, please try again.',
  documentDownloadSuccessMessage: 'Document downloaded successfully.',
  documentUploadSuccessMessage: 'Document uploaded successfully.',
  documentDownloadErrorMessage: 'Error downloading document.',
  documentDeletedSuccessMessage: 'Document deleted Successfully.',
  documentDeletedErrorMessage: 'Error deleting document.',
  documentUploadErrorMessage: 'Error uploading document.',
  inquiryClosedSuccessMessage: 'Inquiry closed Successfully.',
  inquiryClosedErrorMessage: 'Error closing Inquiry.',
  createReasonCodeSuccessNotification: 'Reason code created successfully.',
  createReasonCodeFailedNotification:
    'Reason code creation failed. Please check the form and try again.',
  editReasonCodeSuccessNotification: 'Reason code updated successfully.',
  editReasonCodeFailedNotification: 'Error updating reason code, please try again.',
  createAppealResponseSuccessNotification: 'Appeal response created successfully.',
  createAppealResponseFailNotification: 'Error creating appeal response, please try again.',
  editAppealResponseSuccessNotification: 'Appeal response updated successfully.',
  editAppealResponseFailedNotification: 'Error updating appeal response, please try again.',
  createDocumentReferenceSuccessNotification: 'Document reference created successfully.',
  createDocumentReferenceFailNotification: 'Error creating a document reference, please try again.',
  addFeeScheduleSuccessNotification: 'Fee schedule created successfully.',
  addFeeScheduleFailNotification: 'Error creating fee schedule, please try again.',
  addFeeScheduleConflictNotification:
    'Error creating fee schedule due to conflict, please try again.',
  terminateFeeScheduleSuccessNotification: 'Fee schedule terminated successfully.',
  terminateFeeScheduleFailNotification: 'Error terminating fee schedule, please try again.',
  claimsExportSuccessNotification: 'Claims export file was downloaded successfully.',
  claimsOperationSuccessNotification: 'Claim operation updated successfully.',
  addActivityLogFailNotification: 'Error creating the activity log, please try again.',
  addActivityLogSuccessNotification: 'Activity log created successfully.',
  updateAssigneeSuccessNotification: 'User updated successfully.',
  addAssigneeSuccessNotification: 'User added successfully',
  createInvoiceFailNotification: 'Invoice creation failed. Please check the form and try again.',
  createInvoiceSuccessNotification: 'Invoice generation request created successfully.',
};

export const notificationTypes = {
  positive: 'positive',
  negative: 'negative',
  caution: 'caution',
  activity: 'activity',
};

export const FOOTER_PADDING = '40px';
export const MASTHEAD_HEIGHT = '48px';

export type GridConfigPayload = {
  cfgName: string;
  cfgValue: string;
};
